module.exports = __webpack_public_path__ + "static/img/4.af3d1a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/sp/4.png
// module id = 8Ef5
// module chunks = 0